import { render, staticRenderFns } from "./JinyPrijemceSelect.vue?vue&type=template&id=562d4eac&"
import script from "./JinyPrijemceSelect.vue?vue&type=script&lang=ts&"
export * from "./JinyPrijemceSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports